import React from "react";

const SurveyReportIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41.185"
      height="38.243"
      viewBox="0 0 41.185 38.243"
    >
      <g id="db96" transform="translate(-177.097 -196.04)">
        <path
          id="Path_1818"
          data-name="Path 1818"
          d="M232.312,556.938h-7.354a.49.49,0,0,1,0-.981h7.355A.49.49,0,0,1,232.312,556.938Z"
          transform="translate(-42.466 -322.655)"
          fill={fill ? fill : "#4166F8"}
        />
        <path
          id="Path_1819"
          data-name="Path 1819"
          d="M217.3,196.04H178.078a.98.98,0,0,0-.981.981v27.457a.98.98,0,0,0,.981.981H217.3a.98.98,0,0,0,.981-.981V197.021A.98.98,0,0,0,217.3,196.04Zm-31.869,25.986a2.942,2.942,0,1,1,2.942-2.942A2.941,2.941,0,0,1,185.432,222.026Zm0-8.335a2.942,2.942,0,1,1,2.942-2.942A2.941,2.941,0,0,1,185.432,213.691Zm5.74-14.16-5.556,5.557a.49.49,0,0,1-.693,0l-2.778-2.778a.49.49,0,0,1,0-.693l.693-.693a.49.49,0,0,1,.693,0l1.392,1.392a.49.49,0,0,0,.693,0l4.17-4.17a.49.49,0,0,1,.693,0l.693.693a.49.49,0,0,1,0,.693Zm25.148,20.042a.49.49,0,0,1-.49.49H193.767a.49.49,0,0,1-.49-.49v-.981a.49.49,0,0,1,.49-.49H215.83a.49.49,0,0,1,.49.49Zm0-8.335a.49.49,0,0,1-.49.49H193.767a.49.49,0,0,1-.49-.49v-.981a.49.49,0,0,1,.49-.49H215.83a.49.49,0,0,1,.49.49Zm0-8.335a.49.49,0,0,1-.49.49H193.767a.49.49,0,0,1-.49-.49v-.981a.49.49,0,0,1,.49-.49H215.83a.49.49,0,0,1,.49.49Z"
          transform="translate(0)"
          fill={fill ? fill : "#4166F8"}
        />
        <path
          id="Path_1820"
          data-name="Path 1820"
          d="M495.108,510.782l-3.38,1.69a.489.489,0,0,1-.219.052h-1.6a.245.245,0,0,1-.245-.245v-3.432a.245.245,0,0,1,.245-.245h1.6a.487.487,0,0,1,.219.052l3.38,1.69A.245.245,0,0,1,495.108,510.782Z"
          transform="translate(-280.206 -280.202)"
          fill={fill ? fill : "#4166F8"}
        />
        <path
          id="Path_1821"
          data-name="Path 1821"
          d="M210.417,508.847v3.432a.245.245,0,0,1-.245.245h-2.7a1.961,1.961,0,0,1-1.952-2.154,2.017,2.017,0,0,1,2.036-1.769h2.612a.245.245,0,0,1,.245.245Z"
          transform="translate(-25.475 -280.203)"
          fill={fill ? fill : "#4166F8"}
        />
        <path
          id="Path_1822"
          data-name="Path 1822"
          d="M272.058,508.61h20.1a.245.245,0,0,1,.245.245v3.432a.245.245,0,0,1-.245.245h-20.1a.245.245,0,0,1-.245-.245v-3.432A.245.245,0,0,1,272.058,508.61Z"
          transform="translate(-84.91 -280.21)"
          fill={fill ? fill : "#4166F8"}
        />
      </g>
    </svg>
  );
};

export default SurveyReportIcon;
